import usePrevious from '../usePrevious';
const useHasValueChanged = (value) => {
    const previousValue = usePrevious(value);
    return value !== previousValue;
};
export default useHasValueChanged;
//# sourceMappingURL=index.js.map